import serverCheck from "../../modules/serverCheck";
import toast from "../../modules/toast";
import BaseService from "../BaseService";

class IndustryTypeService extends BaseService {
  baseUrl = `${serverCheck.getServer().serverTmsCustomer}/`;
  cacheOptions = {
    prefix: "industry-type",
    ttl: 1 * 60 // 1 hour
  };

  lookup = async () => {
    try {
      const res = await this.httpClient.get("account-industry-type");
      return res.data.data;
    } catch (error) {
      toast.displayToast({
        type: "error",
        titleText: "Error",
        bodyMessageText:
          "There was an error getting industry types. Please try again."
      });
      console.error(error);
    }
  };

  subTypeLookup = async () => {
    try {
      const res = await this.httpClient.get("account-industry-sub-type");
      const rec = res.data.data.map((item) => {
        return {
          industrySubTypeId: item.industrySubTypeId,
          description: item.description,
          industryTypeId:
            item.industryTypeSubTypeMappings?.[0]?.industryTypeId || null
        };
      });
      return rec;
    } catch (error) {
      toast.displayToast({
        type: "error",
        titleText: "Error",
        bodyMessageText:
          "There was an error getting industry sub types. Please try again."
      });
      console.error(error);
    }
  };
}

const industryTypeService = new IndustryTypeService();

export default industryTypeService;
